import { Component, computed, inject, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { OutOfStockFirstConfig } from '@shared/models';
import { DaysLeftPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant1',
  imports: [SafePipe],
  providers: [DaysLeftPipe, VariableReplacementPipe],
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
})
export class Variant1Component extends BaseComponent {
  config = input.required<OutOfStockFirstConfig>();

  private readonly replaceVars = inject(VariableReplacementPipe);
  private readonly daysLeftPipe = inject(DaysLeftPipe);

  private daysUntilCurrentCampaignEnd = computed(() => {
    const currentCampaign = this.dataService.currentCampaign();
    if (!currentCampaign?.endDate) return null;

    const daysDiff = Number(
      this.daysLeftPipe.transform(currentCampaign.endDate)
    );
    return Number.isFinite(daysDiff) && daysDiff >= 0 ? daysDiff : null;
  });

  displayText = computed(() => {
    const banner = this.config().banner;
    if (!banner) return '';

    const daysLeft = this.daysUntilCurrentCampaignEnd();
    if (daysLeft === null || daysLeft === 0) {
      return banner.text ?? '';
    }

    const countdownText = banner.countdownText;
    if (typeof countdownText !== 'string' || countdownText.trim() === '') {
      return banner.text ?? '';
    }

    const threshold = this.config().daysThreshold ?? 7;
    if (daysLeft > threshold) {
      return banner.text ?? '';
    }

    return this.replaceVars.transform(countdownText, daysLeft);
  });
}
